import { EntityState } from '@reduxjs/toolkit';
import { FetchStatus } from 'core/utils';

export enum ReportType {
  // eslint-disable-next-line no-unused-vars
  TABLE = 'table',
  // eslint-disable-next-line no-unused-vars
  PBI = 'pbi',
}

export interface ProjectsState {
  projects: EntityState<Project, string>;
  activeProjectKey: string;
  status: FetchStatus;
  hierarchyStatus: FetchStatus;
  error: ApiError | null;
}

// Interfaces based on OpenAPI spec
export interface AddBookmark {
  name: string;
  reportState: string;
  type: ReportType;
}

export interface UpdateBookmark {
  name: string;
  reportState: string;
}

export interface Bookmark {
  id: number;
  name: string;
  reportState: string;
  type: ReportType;
  reportId: string;
}

export interface PbiView {
  id: string;
  name?: string;
  workspaceId: string;
  paginatedReport?: {
    id: string;
  };
}

export interface TableView {
  routingKey: string;
}

export interface NavigationData {
  id: string;
  categoryName: string;
  nodeType: 'category';
  children: (Report | Category)[];
}

export interface Report {
  id: string;
  name: string;
  bookmarks: Bookmark[];
  pbiView: PbiView;
  tableView?: TableView;
  nodeType: NavigationItemType;
  helpUrl: string;
}

export interface Category {
  id: string;
  categoryName: string;
  nodeType: NavigationItemType;
  children: (Report | Category)[];
}

export enum NavigationItemType {
  // eslint-disable-next-line no-unused-vars
  REPORT = 'report',
  // eslint-disable-next-line no-unused-vars
  CATEGORY = 'category',
  // eslint-disable-next-line no-unused-vars
  BOOKMARK = 'bookmark',
}

export interface Project {
  key: string;
  name: string;
  workspaces: Workspace[];
}

export interface Workspace {
  pbiGroupId: string;
  displayName: string;
}

export interface ApiError {
  code: number;
  msg: string;
}

export interface ReportsResponse {
  workspaceId: string;
  reports: PbiReport[];
}

export interface PbiReport {
  id: string;
  reportType: string;
  name: string;
  category: string;
  workspaceId: string;
  bookmarks?: Bookmark[];
}

export interface ReportToken {
  token: string;
  tokenId: string;
  expiration: string; // expiry date
}
